// === GENERATED FILE ===
// DO NOT EDIT DIRECTLY, EDIT sh-input-text.lit.scss INSTEAD!
import { css } from 'lit';
export default css`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-input-text-label-left=0.5rem] - left of the input label
   */
  --sh-input-text-label-left: 0.5rem;
  /* 
   * @cssprop [--sh-input-text-empty-label-top=0.5rem] - top of the input label when no value
   */
  --sh-input-text-empty-label-top: 0.5rem;
  /* 
   * @cssprop [--sh-input-text-empty-label-line-height=1.5rem] - line-height of the input label when no value
   */
  --sh-input-text-empty-label-line-height: 1.5rem;
  /* 
   * @cssprop [--sh-input-text-empty-padding=0.5rem 0 0.4375rem 0.5rem] - padding of the input-text when no value
   */
  --sh-input-text-empty-padding: 0.5rem 0 0.4375rem 0.5rem;
  /* 
   * @cssprop [--sh-input-text-height=2.4375rem] - height of the input-text
   */
  --sh-input-text-height: 2.4375rem;
  /* 
   * @cssprop [--sh-input-text-padding=1.25rem 0 0.1875rem 0.5rem] - padding of the input-text with value
   */
  --sh-input-text-padding: 1.25rem 0 0.1875rem 0.5rem;
  /* 
   * @cssprop [--sh-input-text-label-top=0.25rem] - top of the input label with value
   */
  --sh-input-text-label-top: 0.25rem;
  /* 
   * @cssprop [--sh-input-text-label-line-height=1rem] - line-height of the input label with value
   */
  --sh-input-text-label-line-height: 1rem;
  /* 
   * @cssprop [--sh-input-text-empty-no-border-padding-bottom=0.5rem] - padding-bottom of the input when no border
   */
  --sh-input-text-empty-no-border-padding-bottom: 0.5rem;
  /* 
   * @cssprop [--sh-input-text-no-border-padding-bottom=0.25rem] - padding-bottom of the input with value when no border
   */
  --sh-input-text-no-border-padding-bottom: 0.25rem;
  /* 
   * @cssprop [--sh-input-text-no-border-condensed-padding-bottom=0.25rem] - padding-bottom of the condensed input when no border
   */
  --sh-input-text-no-border-condensed-padding-bottom: 0.25rem;
  /* 
   * @cssprop [--sh-input-text-icon-left-margin=0.5rem] - margin-left of the icon
   */
  --sh-input-text-icon-left-margin: 0.5rem;
  /* 
   * @cssprop [--sh-input-text-slot-icon-left-margin=0.5rem] - margin-left of the icon placed in the slot
   */
  --sh-input-text-slot-icon-left-margin: 0.5rem;
  /* 
   * @cssprop [--sh-input-text-icon-wrapper-right-padding=0.5rem] - right-padding of the icon-wrapper
   */
  --sh-input-text-icon-wrapper-right-padding: 0.5rem;
  /* 
   * @cssprop [--sh-input-text-icon-size=1.5rem] - size of the icon
   */
  --sh-input-text-icon-size: 1.5rem;
  /* 
   * @cssprop [--sh-input-text-icon-wrapper-margin=0rem] - margin-bottom of the icon
   */
  --sh-input-text-icon-wrapper-margin: 0rem;
  /* 
   * @cssprop [--sh-input-text-helper-text-padding=0.25rem 0.5rem 0] - padding of the helper-text
   */
  --sh-input-text-helper-text-padding: 0.25rem 0.5rem 0;
  /* 
   * @cssprop [--sh-input-text-condensed-label-top=0.25rem] - top of the condensed label
   */
  --sh-input-text-condensed-label-top: 0.25rem;
  /* 
   * @cssprop [--sh-input-text-condensed-padding=0.25rem 0 0.1875rem 0.5rem] - padding of the condensed input
   */
  --sh-input-text-condensed-padding: 0.25rem 0 0.1875rem 0.5rem;
  /* 
   * @cssprop [--sh-input-text-condensed-height=1.9375rem] - height of the condensed input
   */
  --sh-input-text-condensed-height: 1.9375rem;
  /* 
   * @cssprop [--sh-input-text-textarea-label-height=1.5rem] - height of the textarea label
   */
  --sh-input-text-textarea-label-height: 1.5rem;
  /* 
   * @cssprop [--sh-input-text-textarea-label-padding=0.25rem 0 0.25rem 0.5rem] - padding of the textarea label
   */
  --sh-input-text-textarea-label-padding: 0.25rem 0 0.25rem 0.5rem;
  /* 
   * @cssprop [--sh-input-text-textarea-padding=0 0.5rem 0.3125rem] - padding of the textarea
   */
  --sh-input-text-textarea-padding: 0 0.5rem 0.3125rem;
  /* 
   * @cssprop [--sh-input-text-textarea-line-height=1.0625rem] - line-height of the textarea
   */
  --sh-input-text-textarea-line-height: 1.0625rem;
  /* 
   * @cssprop [--sh-input-text-textarea-empty-label-line-height=1.25rem] - line-height of the empty textarea (without value)
   */
  --sh-input-text-textarea-empty-label-line-height: 1.25rem;
  /* 
   * @cssprop [--sh-input-text-condensed-textarea-top=0.25rem] - top of the icon-wrapper and label of condensed textarea
   */
  --sh-input-text-condensed-textarea-top: 0.25rem;
  /* 
   * @cssprop [--sh-input-text-condensed-textarea-padding=0.25rem 0 0.3125rem 0.5rem] - padding of the div of condensed textarea
   */
  --sh-input-text-condensed-textarea-padding: 0.25rem 0 0.3125rem 0.5rem;
  /* 
   * @cssprop [--sh-input-text-textarea-label-line-height=1rem] - line-height of the label of textarea with value
   */
  --sh-input-text-textarea-label-line-height: 1rem;
  /* 
   * @cssprop [--sh-input-text-condensed-textarea-icon-top=0.25rem] - top of the icon of condensed textarea with value
   */
  --sh-input-text-condensed-textarea-icon-top: 0.25rem;
  /* 
   * @cssprop [--sh-input-text-pointer-events=none] - pointer events of the input text label
   */
  --sh-input-text-pointer-events: none;
  /* 
   * @cssprop [--sh-input-text-label-condensed-display=none] - condensed label display
   */
  --sh-input-text-label-condensed-display: none;
  /* 
   * @cssprop [--sh-input-text-input-cursor=text] - cursor for the input
   */
  --sh-input-text-input-cursor: text;
  /* 
   * @cssprop [--sh-input-text-border-radius=var(--sh-radius-control) var(--sh-radius-control) 0 0] - border-radius of the input-text
   */
  --sh-input-text-border-radius: var(--sh-radius-control) var(--sh-radius-control) 0 0;
  /* 
   * @cssprop [--sh-input-text-background-idle=rgba(var(--ui-1), var(--opacity-50))] - Background color for input fields when they are in an idle or disabled state
   */
  --sh-input-text-background-idle: rgba(var(--ui-1), var(--opacity-50));
  /* 
   * @cssprop [--sh-input-text-background-hover=rgba(var(--ui-1), var(--opacity-100))] - Background color for input fields when they are in hover state
   */
  --sh-input-text-background-hover: rgba(var(--ui-1), var(--opacity-100));
  /* 
   * @cssprop [--sh-input-text-background-readonly=transparent] - Background color for input fields when they are in readonly state
   */
  --sh-input-text-background-readonly: transparent;
  /* 
   * @cssprop [--sh-input-text-background-disabled=rgba(var(--ui-1), var(--opacity-50))] - Background color for input fields when they are in disabled state
   */
  --sh-input-text-background-disabled: rgba(var(--ui-1), var(--opacity-50));
  /* 
   * @cssprop [--sh-input-text-border=rgba(var(--ui-1), var(--opacity-400))] - border color when they are in idle , hover and disabled state
   */
  --sh-input-text-border: rgba(var(--ui-1), var(--opacity-400));
  /* 
   * @cssprop [--sh-input-text-border-focus=rgba(var(--ui-1), var(--opacity-900))] - border color when they are in focus state
   */
  --sh-input-text-border-focus: rgba(var(--ui-1), var(--opacity-900));
  /* 
   * @cssprop [--sh-input-text-full-border-readonly=transparent] - full border color when they are in readonly no-border state
   */
  --sh-input-text-full-border-readonly: transparent;
  /* 
   * @cssprop [--sh-input-text-border-error=rgba(var(--functional-red))] -  border color when they are in error state
   */
  --sh-input-text-border-error: rgba(var(--functional-red));
  /* 
   * @cssprop [--sh-input-text-border-success=rgba(var(--functional-green), var(--opacity-1000))] -  border color when they are in success state
   */
  --sh-input-text-border-success: rgba(var(--functional-green), var(--opacity-1000));
  /* 
   * @cssprop [--sh-input-text-border-safety=rgba(var(--functional-yellow))] -  border color when they are in safety state
   */
  --sh-input-text-border-safety: rgba(var(--functional-yellow));
  /* 
   * @cssprop [--sh-input-text-font-1=var(--body-1)] - font type --body-1
   */
  --sh-input-text-font-1: var(--body-1);
  /* 
   * @cssprop [--sh-input-text-font-2=var(--body-2)] - font type --body-2
   */
  --sh-input-text-font-2: var(--body-2);
  /* 
   * @cssprop [--sh-input-text-subtle-color=var(--color-text-subtle)] - font color subtle
   */
  --sh-input-text-subtle-color: var(--color-text-subtle);
  /* 
   * @cssprop [--sh-input-text-strong-color=var(--color-text-strong)] - font color strong
   */
  --sh-input-text-strong-color: var(--color-text-strong);
  /* 
   * @cssprop [--sh-input-text-disabled-text=var(--color-text-disabled)] - font colo in disabled state
   */
  --sh-input-text-disabled-text: var(--color-text-disabled);
}

[theme=light],
[theme=dark] {
  /* Input Background States */
  --sh-input-background-focus: rgba(var(--ui-1), var(--opacity-75));
  --sh-input-border-readonly: rgba(var(--ui-1), var(--opacity-200));
  /* Full Border (No-Border Variant) */
  --sh-input-full-border-focus: rgba(var(--ui-1), var(--opacity-300));
  /* Input Background States (Error Variant) */
  --sh-input-background-idle-error: var(--tint-error-150);
  --sh-input-background-hover-error: var(--tint-error-250);
  --sh-input-background-focus-error: var(--tint-error-200);
  --sh-input-no-border-error: rgba(var(--functional-red));
  --sh-input-border-error-shadow: 0 0.0625rem 0 0 var(--sh-input-text-border-error);
  /* Input Background States (Success Variant) */
  --sh-input-background-idle-success: var(--tint-success-150);
  --sh-input-background-hover-success: var(--tint-success-250);
  --sh-input-background-focus-success: var(--tint-success-200);
  --sh-input-no-border-success: rgba(var(--functional-green), var(--opacity-1000));
  --sh-input-border-success-shadow: 0 0.0625rem 0 0 var(--sh-input-text-border-success);
  /* Input Background States (Safety Variant) */
  --sh-input-background-idle-safety: rgba(var(--ui-1), var(--opacity-50));
  --sh-input-background-hover-safety: rgba(var(--ui-1), var(--opacity-100));
  --sh-input-background-focus-safety: rgba(var(--ui-1), var(--opacity-75));
  --sh-input-no-border-safety: rgba(var(--functional-yellow));
  --sh-input-border-safety-shadow: 0 0.0625rem 0 0 var(--sh-input-text-border-safety);
  /* Input Background States (Warning Variant) */
  --sh-input-background-idle-warning: var(--tint-warning-150);
  --sh-input-background-hover-warning: var(--tint-warning-250);
  --sh-input-background-focus-warning: var(--tint-warning-200);
  /* Error Text */
  --sh-error-text-color: var(--color-text-error);
}

:host {
  width: 100%;
  height: auto;
  position: relative;
  display: flex;
  flex-direction: column;
}

.outer-wrapper {
  display: flex;
  flex-direction: column;
  border-radius: var(--sh-radius-control) var(--sh-radius-control) 0 0;
  border-bottom-width: 0.0625rem;
}

:host([no-border]) .outer-wrapper {
  display: flex;
  flex-direction: column;
  border-radius: var(--sh-radius-control);
}

.input-wrapper {
  display: flex;
  flex-direction: row;
  border-radius: var(--sh-input-text-border-radius);
  border-bottom: 0.0625rem solid transparent;
  border-color: var(--sh-input-text-border);
  transition: var(--hover-transition-time);
}

:host(.touch-device) .input-wrapper {
  transition: none;
}

:host([has-focus]) .outer-wrapper {
  outline: var(--focus-outline);
  outline-offset: 0rem;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
}

.input-text-label {
  font: var(--body-1);
  color: var(--color-text-subtle);
  position: absolute;
  left: var(--sh-input-text-label-left);
  width: calc(100% - var(--sh-input-text-label-left));
  transition: var(--transition-time) all ease-in-out;
  pointer-events: var(--sh-input-text-pointer-events);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  top: var(--sh-input-text-empty-label-top);
  line-height: var(--sh-input-text-empty-label-line-height);
  display: flex;
  align-items: center;
}

.label-wrapper {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: fit-content;
  cursor: pointer;
}

input {
  outline: none;
  border: none;
  font: var(--body-1);
  color: var(--color-text-strong);
  background: transparent;
  height: var(--sh-input-text-height);
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: var(--transition-time) all ease-in-out;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  -webkit-appearance: none;
  cursor: var(--sh-input-text-input-cursor);
  padding: var(--sh-input-text-padding);
}

:host(:not([disabled])) input {
  -webkit-background-clip: text;
  background-clip: text;
  caret-color: var(--text-primary);
  -webkit-text-fill-color: var(--text-primary);
}

:host(.empty) input {
  padding: var(--sh-input-text-empty-padding);
}

:host([no-border]:not([textarea]):not([condensed])) input {
  height: calc(var(--sh-input-text-height) + 0.0625rem);
  padding-bottom: var(--sh-input-text-empty-no-border-padding-bottom);
}

:host([no-border]:not([textarea]):not([condensed]):not(.empty)) input {
  height: calc(var(--sh-input-text-height) + 0.0625rem);
  padding-bottom: var(--sh-input-text-no-border-padding-bottom);
}

:host([condensed][no-border]:not([textarea])) input,
:host([condensed][no-clear][no-border]:not([textarea])) input {
  padding-bottom: var(--sh-input-text-no-border-condensed-padding-bottom);
  height: calc(var(--sh-input-text-condensed-height) + 0.0625rem);
}

:host(:not(.empty)) .input-text-label,
:host(:not([readonly]):not([disabled])) input:focus + .input-text-label,
:host(:not([readonly]):not([disabled])[show-outline]) .input-text-label {
  top: var(--sh-input-text-label-top);
  font: var(--body-2);
  color: var(--color-text-subtle);
  line-height: var(--sh-input-text-label-line-height);
}

:host(:not([show-outline])[value=""][show-tooltip]) input:focus + .input-text-label {
  top: var(--sh-input-text-empty-label-top);
  font: var(--body-1);
  line-height: var(--sh-input-text-empty-label-line-height);
}

:host(:not([show-outline])[condensed][value=""][show-tooltip]) input:focus + .input-text-label {
  top: var(--sh-input-text-condensed-label-top);
  font: var(--body-1);
  line-height: var(--sh-input-text-empty-label-line-height);
}

:host(:not([readonly])) .textarea:focus + .input-text-label,
:host([textarea]:not(.empty)) .input-text-label,
:host([textarea][textarea-focused]) .input-text-label {
  font: var(--body-2);
  line-height: var(--sh-input-text-textarea-label-line-height);
}

input::-ms-clear,
input::-ms-reveal {
  display: none;
}

.icon-wrapper {
  position: relative;
  align-items: center;
  right: 0;
  display: flex;
  padding-right: var(--sh-input-text-icon-wrapper-right-padding);
  width: fit-content;
  border-radius: 0 0.125rem 0 0;
}

:host([textarea]) .icon-wrapper {
  margin-bottom: var(--sh-input-text-icon-wrapper-margin);
}

:host([textarea][condensed]) .icon-wrapper {
  height: fit-content;
  top: var(--sh-input-text-condensed-textarea-top);
}

:host([textarea][condensed]:not(.empty):hover:not(.touch-device)) .icon-wrapper,
:host([textarea][condensed][error]:not(.empty)) .icon-wrapper {
  top: var(--sh-input-text-condensed-textarea-icon-top);
}

.icon-wrapper > sh-icon[icon=error],
.icon-wrapper > sh-icon[icon=success] {
  margin-left: var(--sh-input-text-icon-left-margin);
}

:host([condensed]) .icon-wrapper > ::slotted(sh-icon),
.icon-wrapper > ::slotted(sh-icon) {
  margin-left: var(--sh-input-text-slot-icon-left-margin);
}

:host([condensed]:not([textarea])) #clear,
:host([condensed]:not([textarea])) .icon-wrapper > ::slotted(sh-icon) {
  --sh-icon-size-s: var(--sh-input-text-icon-size) !important;
}

/* disabled */
input:disabled,
textarea:disabled {
  opacity: unset;
}

/* Input (Disabled)	*/
:host([disabled]) .input-text-label,
:host([disabled][textarea]) .input-text-label,
:host([disabled]) input,
:host([disabled]) .textarea {
  color: var(--color-text-disabled);
}

:host([mandatory][disabled]) #mandatory {
  color: rgba(var(--ui-2), var(--opacity-5));
}

:host([disabled]) .icon-wrapper > ::slotted(*) {
  pointer-events: none;
  color: var(--color-text-disabled);
}

:host([disabled][textarea]) .textarea {
  color: var(--color-text-disabled);
}

/* Validation Styles */
:host([mandatory]) #mandatory {
  display: inline-block;
  color: rgba(var(--ui-2), var(--opacity-1));
}

:host([error]) .input-wrapper,
:host([textarea][error][condensed]) .input-wrapper,
:host([textarea][error]:not([condensed])) .outer-wrapper {
  box-shadow: var(--sh-input-border-error-shadow);
  border-color: var(--sh-input-text-border-error);
  border-bottom-style: solid;
}

/* success bottom, border */
:host([success]) .input-wrapper,
:host([textarea][success][condensed]) .input-wrapper,
:host([textarea][success]:not([condensed])) .outer-wrapper {
  box-shadow: var(--sh-input-border-success-shadow);
  border-color: var(--sh-input-text-border-success);
  border-bottom-style: solid;
}

:host([safety]) .input-wrapper,
:host([textarea][safety][condensed]) .input-wrapper,
:host([textarea][safety]:not([condensed])) .outer-wrapper {
  box-shadow: var(--sh-input-border-safety-shadow);
  border-color: var(--sh-input-text-border-safety);
  border-bottom-style: solid;
}

/* focus */
:host(:not([error]):not([success]):not([safety]):not([readonly]):not([disabled]):not([no-border])) .input-wrapper:focus-within,
:host([show-outline]:not([error]):not([success]):not([safety]):not([readonly]):not([disabled])) .input-wrapper {
  border-color: var(--sh-input-text-border-focus);
}

:host([readonly]:not([error]):not([success]):not([safety])) .input-wrapper:focus-within {
  border-color: var(--sh-input-text-border-focus);
}

:host([no-border][textarea]:not([readonly])) .outer-wrapper:focus-within,
:host([no-border]:not([textarea]):not([readonly])) .input-wrapper:focus-within {
  box-shadow: inset 0 0 0 0.0625rem var(--sh-input-full-border-focus, Transparent);
}

:host(.empty:not([condensed])) input:focus,
.textarea:focus {
  padding: var(--sh-input-text-padding);
}

/* readonly */
:host([readonly]:not([error]):not([success]):not([safety]):not([no-border])) .input-wrapper,
:host([readonly]:not([error]):not([success]):not([safety]):not([no-border])) .textarea {
  background: transparent;
  border-color: var(--sh-input-border-readonly, rgba(var(--ui-1), var(--opacity-400)));
}

:host([readonly]) input,
:host([readonly]) .textarea,
:host([disabled]) input,
:host([disabled]) .textarea {
  cursor: default;
  overflow: hidden;
  text-overflow: ellipsis;
}

:host([value=""][readonly]),
:host([disabled]) input,
:host([disabled]) .textarea {
  pointer-events: none;
}

/* Clear Field Icon */
#clear {
  opacity: 0;
  z-index: -1;
  padding: unset;
  pointer-events: none;
  transition: none;
  cursor: pointer;
  --sh-icon-size-s: 0;
  --sh-icon-font-size-s: 0;
}

:host([error]:not([value=""])) #clear {
  opacity: 1;
  z-index: auto;
  margin-left: var(--sh-input-text-icon-left-margin);
  --sh-icon-size-s: unset;
  --sh-icon-font-size-s: unset;
}

:host(.touch-device) #clear {
  opacity: 1;
  z-index: auto;
  pointer-events: all;
  --sh-icon-size-s: unset;
  --sh-icon-font-size-s: unset;
}

/* No Clear */
/* hover */
:host(:not([readonly]):not([disabled]):not(.empty)[textarea]) .outer-wrapper:hover #clear,
:host(:not([readonly]):not([disabled]):not(.empty):hover:not(.touch-device)) .input-wrapper:hover #clear,
:host(:not([readonly]):not([disabled]):not(.empty).touch-device):hover .input-wrapper:hover #clear,
#clear:focus {
  pointer-events: all;
  opacity: 1;
  z-index: auto;
  margin-left: var(--sh-input-text-icon-left-margin);
  --sh-icon-size-s: unset;
  --sh-icon-font-size-s: unset;
}

:host([condensed]:not([readonly]):not([disabled]):not(.empty):hover:not(.touch-device)) .input-wrapper:hover #clear,
:host([condensed]:not([readonly]):not([disabled]):not(.empty).touch-device):hover .input-wrapper:hover #clear,
:host([condensed]) #clear:focus,
:host([condensed]) .icon-wrapper > sh-icon[icon=error],
:host([condensed]) .icon-wrapper > sh-icon[icon=success],
:host([condensed][error]:not([value=""])) #clear {
  margin-left: var(--sh-input-text-icon-left-margin);
}

/* helper text */
.helper-text {
  padding: var(--sh-input-text-helper-text-padding);
  box-sizing: border-box;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  visibility: visible;
  cursor: text !important;
  font: var(--body-2);
  color: var(--color-text-subtle);
  line-height: var(--sh-text-body2-line-height);
}

/*condensed*/
:host([condensed]) .input-text-label,
:host([condensed]:not([show-tooltip])) input:focus + .input-text-label,
:host([condensed][textarea]) .textarea:focus + .input-text-label {
  display: none;
}

:host([show-tooltip]:not([disabled]):not([readonly])) .input-text-label {
  pointer-events: all;
}

:host([condensed][textarea]) #shinputDiv {
  padding: var(--sh-input-text-condensed-textarea-padding);
}

:host(.empty[condensed][readonly]) input:focus + .input-text-label {
  display: flex;
}

:host(.empty[condensed]) .input-text-label {
  display: flex;
  top: var(--sh-input-text-condensed-label-top);
}

:host(.empty[textarea][condensed]) .input-text-label {
  line-height: var(--sh-input-text-textarea-line-height);
  top: unset;
  height: unset;
}

:host([condensed]) input,
:host([condensed][no-clear]) input {
  padding: var(--sh-input-text-condensed-padding);
  height: var(--sh-input-text-condensed-height);
}

/*textarea*/
:host([textarea]:not([disabled]):not([readonly]):not[no-border]) .outer-wrapper {
  transition: var(--transition-time) all ease-in-out, var(--hover-transition-time) background, 0s outline, 0s height;
  border-bottom: 0.0625rem solid transparent;
  border-color: var(--sh-input-text-border);
  border-radius: 0.125rem 0.125rem 0 0;
}

:host([textarea][no-border]) .outer-wrapper,
:host([no-border]) .input-wrapper {
  border-radius: var(--sh-radius-control);
}

:host([textarea]) .input-text-label {
  background-color: transparent;
  transition: color var(--transition-time) ease-in-out, font var(--transition-time) ease-in-out, top var(--transition-time) ease-in-out, line-height var(--transition-time) ease-in-out;
  height: var(--sh-input-text-textarea-label-height);
  line-height: var(--sh-input-text-textarea-empty-label-line-height);
}

:host([textarea]:not([condensed])) .input-text-label {
  position: relative;
  width: 100%;
  top: unset;
  left: unset;
}

:host([textarea]:not([condensed])) .content-wrapper {
  border-radius: 0.125rem 0 0 0;
}

:host([textarea]) .textarea,
:host([readonly][textarea]) .textarea:focus {
  outline: none;
  border: none;
  font: var(--body-1);
  color: var(--color-text-strong);
  background-color: transparent;
  width: 100%;
  box-sizing: border-box;
  padding: 0rem;
  resize: none;
  overflow-y: auto;
  line-height: var(--sh-input-text-textarea-line-height);
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
}

:host([textarea]) .input-wrapper {
  transition: none;
  border-bottom: none;
  border-bottom-width: 0.0625rem;
  border-color: unset;
  border-radius: unset;
  background: none;
  box-shadow: none;
}

:host([error][no-border]:not([textarea])) .input-wrapper {
  box-shadow: inset 0 0 0 0.0625rem var(--sh-input-no-border-error, transparent);
}

:host([safety][no-border]:not([textarea])) .input-wrapper {
  box-shadow: inset 0 0 0 0.0625rem var(--sh-input-no-border-safety, transparent);
}

:host([success][no-border]:not([textarea])) .input-wrapper,
:host([success][no-border][textarea]) .output-wrapper {
  box-shadow: inset 0 0 0 0.0625rem var(--sh-input-no-border-success, transparent);
}

:host([safety][no-border]:not([textarea])) .input-wrapper,
:host([safety][no-border][textarea]) .output-wrapper {
  box-shadow: inset 0 0 0 0.0625rem var(--sh-input-no-border-safety, transparent);
}

:host([textarea]:not([condensed])) .textarea,
:host([textarea][readonly]:not([condensed])) .textarea {
  padding: var(--sh-input-text-textarea-padding);
}

:host(:not([disabled]):not([readonly])[textarea]) .outer-wrapper:hover {
  background: rgba(var(--ui-1), var(--opacity-6));
}

/*default */
:host(:not([disabled]):not([readonly])) .outer-wrapper,
:host(:not([disabled]):not([readonly])[textarea]) .outer-wrapper {
  background: var(--sh-input-text-background-idle);
}

:host(:not([disabled]):not([readonly])[textarea]:not([no-border]):not([safety]):not([error]):not([success])) .outer-wrapper:hover,
:host([disabled]:not([readonly])[textarea]:not([no-border]):not([safety]):not([error]):not([success])) .outer-wrapper:hover,
:host([disabled]:not([readonly])[textarea]:not([no-border]):not([safety]):not([error]):not([success])) .outer-wrapper,
:host(:not([disabled]):not([readonly])[textarea]:not([no-border]):not([safety]):not([error]):not([success])) .outer-wrapper {
  border-color: var(--sh-input-text-border);
  border-bottom: 0.0625rem solid var(--sh-input-text-border);
  border-radius: var(--sh-radius-control) var(--sh-radius-control) 0 0;
}

:host(:not([disabled]):not([readonly])) .outer-wrapper:hover,
:host(:not([disabled]):not([readonly])[textarea]) .outer-wrapper:hover {
  background: var(--sh-input-text-background-hover);
}

:host(:not([disabled]):not([readonly]):not([error]):not([success]):not([safety])) .outer-wrapper:focus-within,
:host(:not([disabled]):not([readonly])[textarea]:not([error]):not([success]):not([safety])) .outer-wrapper:focus-within {
  background: var(--sh-input-background-focus, rgba(var(--ui-1), var(--opacity-50)));
}

:host(:not([disabled]):not([readonly]):not([error]):not([success]):not([safety])) .outer-wrapper:focus-within:hover,
:host(:not([disabled]):not([readonly])[textarea]:not([error]):not([success]):not([safety])) .outer-wrapper:focus-within:hover {
  background: var(--sh-input-background-focus, var(--sh-input-text-background-hover));
}

:host(:not([disabled]):not([readonly])[textarea]:not([no-border]):not([safety]):not([error]):not([success])) .outer-wrapper:focus-within {
  border-color: var(--sh-input-text-border-focus);
}

:host(:not([disabled]):not([readonly])[textarea][no-border]:not([error]):not([success]):not([safety])) .outer-wrapper:not(:focus-within) {
  border-color: var(--sh-input-text-full-border-readonly);
  box-shadow: inset 0 0 0 0.0625rem var(--sh-input-text-full-border-readonly);
}

:host([disabled]) .outer-wrapper,
:host([disabled][textarea]) .outer-wrapper {
  background: var(--sh-input-text-background-idle);
}

:host([readonly]) .outer-wrapper {
  background: var(--sh-input-text-background-readonly);
}

:host([readonly][textarea]) .outer-wrapper {
  background: var(--sh-input-text-background-readonly);
  border-color: var(--sh-input-border-readonly, rgba(var(--ui-1), var(--opacity-400)));
  box-shadow: inset 0 -0.0625rem 0 0 var(--sh-input-border-readonly, rgba(var(--ui-1), var(--opacity-400)));
}

/*error */
:host(:not([disabled]):not([readonly])[error]) .outer-wrapper,
:host(:not([disabled]):not([readonly])[error][textarea]) .outer-wrapper {
  background: var(--sh-input-background-idle-error, rgba(var(--ui-1), var(--opacity-50)));
}

:host(:not([disabled]):not([readonly])[error]) .outer-wrapper:hover,
:host(:not([disabled]):not([readonly])[error][textarea]) .outer-wrapper:hover {
  background: var(--sh-input-background-hover-error, rgba(var(--ui-1), var(--opacity-100)));
}

:host(:not([disabled]):not([readonly])[error]) .outer-wrapper:focus-within,
:host(:not([disabled]):not([readonly])[error][textarea]) .outer-wrapper:focus-within {
  background: var(--sh-input-background-focus-error, rgba(var(--ui-1), var(--opacity-50)));
}

:host(:not([disabled]):not([readonly])[error]) .outer-wrapper:focus-within:hover,
:host(:not([disabled]):not([readonly])[error][textarea]) .outer-wrapper:focus-within:hover {
  background: var(--sh-input-background-focus-error, rgba(var(--ui-1), var(--opacity-100)));
}

:host([disabled][error]) .outer-wrapper,
:host([disabled][error][textarea]) .outer-wrapper {
  background: var(--sh-input-text-background-disabled);
}

/*success */
:host([success][textarea]:not([disabled]):not([readonly])) .outer-wrapper,
:host([success]:not([disabled]):not([readonly])) .outer-wrapper {
  background: var(--sh-input-background-idle-success, rgba(var(--ui-1), var(--opacity-50)));
}

:host(:not([disabled]):not([readonly])[success]) .outer-wrapper:hover,
:host(:not([disabled]):not([readonly])[success][textarea]) .outer-wrapper:hover {
  background: var(--sh-input-background-hover-success, rgba(var(--ui-1), var(--opacity-100)));
}

:host(:not([disabled]):not([readonly])[success]) .outer-wrapper:focus-within,
:host(:not([disabled]):not([readonly])[success][textarea]) .outer-wrapper:focus-within {
  background: var(--sh-input-background-focus-success, rgba(var(--ui-1), var(--opacity-50)));
}

:host(:not([disabled]):not([readonly])[success]) .outer-wrapper:focus-within:hover,
:host(:not([disabled]):not([readonly])[success][textarea]) .outer-wrapper:focus-within:hover {
  background: var(--sh-input-background-focus-success, rgba(var(--ui-1), var(--opacity-100)));
}

:host([disabled][success]) .outer-wrapper,
:host([disabled][success][textarea]) .outer-wrapper {
  background: var(--sh-input-text-background-disabled);
}

/*safety*/
:host(:not([disabled]):not([readonly])[safety]) .outer-wrapper,
:host(:not([disabled]):not([readonly])[safety][textarea]) .outer-wrapper {
  background: var(--sh-input-background-idle-safety, rgba(var(--ui-1), var(--opacity-50)));
}

:host(:not([disabled]):not([readonly])[safety]) .outer-wrapper:hover,
:host(:not([disabled]):not([readonly])[safety][textarea]) .outer-wrapper:hover {
  background: var(--sh-input-background-hover-safety, rgba(var(--ui-1), var(--opacity-100)));
}

:host(:not([disabled]):not([readonly])[safety]) .outer-wrapper:focus-within,
:host(:not([disabled]):not([readonly])[safety][textarea]) .outer-wrapper:focus-within {
  background: var(--sh-input-background-focus-safety, rgba(var(--ui-1), var(--opacity-50)));
}

:host(:not([disabled]):not([readonly])[safety]) .outer-wrapper:focus-within:hover,
:host(:not([disabled]):not([readonly])[safety][textarea]) .outer-wrapper:focus-within:hover {
  background: var(--sh-input-background-focus-safety, rgba(var(--ui-1), var(--opacity-100)));
}

:host([disabled][safety]) .outer-wrapper,
:host([disabled][safety][textarea]) .outer-wrapper {
  background: var(--sh-input-text-background-disabled);
}

:host(:not([readonly]):not(.touch-device)[textarea]:hover) input:hover:not(:focus),
:host(:not([readonly]):not(.touch-device)[textarea]:hover) .textarea:hover:not(:focus),
:host([textarea][readonly]) .outer-wrapper,
:host([textarea][readonly]) .input-wrapper {
  background-color: transparent;
}

:host([textarea]) #shinputDiv {
  padding: var(--sh-input-text-textarea-label-padding);
  box-sizing: border-box;
}

:host([textarea]:not([readonly]):not([disabled])) #shinputDiv {
  cursor: text;
}

/* textarea auto height */
:host([textarea][rows=auto]) .content-wrapper,
:host([textarea][rows=auto]) textarea {
  display: flex;
  flex: 1;
}

:host([no-border]) .input-wrapper,
:host([no-border][readonly]) input:focus .input-wrapper,
:host([textarea][no-border]) .outer-wrapper,
:host([textarea][error][condensed][no-border]) .input-wrapper,
:host([textarea][success][condensed][no-border]) .input-wrapper,
:host([textarea][safety][condensed][no-border]) .input-wrapper {
  border-bottom: none;
  border-color: var(--sh-input-text-full-border-readonly);
  box-shadow: inset 0 0 0 0.0625rem var(--sh-input-text-full-border-readonly);
}

:host([textarea]) .textarea {
  resize: none;
}

:host([textarea][resizable]) .textarea {
  resize: vertical;
}

.error-message {
  font: var(--body-2);
  color: var(--sh-error-text-color, var(--color-text-subtle));
  line-height: var(--sh-text-body2-line-height);
}

/* textarea succcess no border */
:host([textarea][no-border][success]) .outer-wrapper {
  box-shadow: inset 0 0 0 0.0625rem var(--sh-input-no-border-success, transparent);
}

/* textarea error no border */
:host([textarea][no-border][error]) .outer-wrapper {
  box-shadow: inset 0 0 0 0.0625rem var(--sh-input-no-border-error, transparent);
}

/* textarea safety no border */
:host([textarea][no-border][safety]) .outer-wrapper {
  box-shadow: inset 0 0 0 0.0625rem var(--sh-input-no-border-safety, transparent);
}`;